import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { AppService } from '../../../app.service';
import { DiagramaFiltroService } from '../diagrama-filtro/diagrama-filtro.service';

@Component({
  selector: 'app-thumb-diagrama',
  templateUrl: './thumb-diagrama.component.html',
  styleUrls: ['./thumb-diagrama.component.scss']
})
export class ThumbDiagramaComponent implements OnInit {

  _LOG = false;
  _PRINT = false;
  loading = false;

  params_URL;
  full_URL;
  URL;

  cont = 0;

  @Input() diagrama: any;
  @Input() type: any;
  @Input() user: any;
  // @Input() page: any;

  constructor(
    private diagramaService: DiagramaFiltroService,
    private route: ActivatedRoute,
    private _router: Router,
    private renderer: Renderer2,
    private element: ElementRef,
    private _appService: AppService,
    private _route: Router,
    private dialog: MatDialog,
    private appService: AppService
  ) { }

 async ngOnInit() {
    this.renderer.setStyle(this.element.nativeElement.offsetParent, 'overflow', 'visible');
    if (this._LOG) console.log('Iniciando thumb diagrama... ')//, console.log(this.diagrama), console.log(this.type), console.log(this.user);
    this.params_URL = this._router.url;
    if (this._LOG) console.log('params URL => ', this.params_URL);

    this.full_URL = window.location.href;
    if (this._LOG) console.log('currentURL => ', this.full_URL);

    this.URL = this.full_URL.split(this.params_URL);
    this.URL = this.URL[0];

    if (this._LOG) console.log('URL =>', this.URL);

    this.user = await this.appService.getUser().value;
  }
  
  private sanitizeForUrl(text: string): string {
    if (!text) return '';
    return text
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '')
      .toLowerCase();
  }

  visualizarDiagrama(diagrama) {
    if (this.user.permissao >= this.diagrama.permissao) {
      const diagramUrl = `/diagram?diagramaId=${diagrama._id}`;
      sessionStorage.setItem('url-back-diagrama', window.location.href);
      localStorage.setItem('url-back-diagrama', window.location.href);
      window.location.assign(diagramUrl);

      if (this._PRINT) console.log(`${this.URL}/diagram`);
    }
    else {
      this._route.navigate([`${environment.url_version}/planos`]);
    }
  }


}
